export default __webpack_public_path__ + "static/media/3.53a1a04c.svg";